import(/* webpackMode: "eager" */ "/app/src/app/finance/currency/page.tsx");
